import { render, staticRenderFns } from "./DataLoader.vue?vue&type=template&id=47d8f42d&scoped=true&"
import script from "./DataLoader.vue?vue&type=script&lang=js&"
export * from "./DataLoader.vue?vue&type=script&lang=js&"
import style0 from "./DataLoader.vue?vue&type=style&index=0&id=47d8f42d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d8f42d",
  null
  
)

export default component.exports